import heroOne from "../../assets/heroOne.webp";
import heroTwo from "../../assets/heroTwo.webp";
import heroThree from "../../assets/heroThree.webp";
import Btn from "../btn/landing-page/Btn";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Pagination, Navigation, EffectFlip, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Slider = () => {
  const { user } = useAuth();

  const hero = [{ image: heroOne }, { image: heroTwo }, { image: heroThree }];

  return (
    <Swiper
      style={{
        "--swiper-navigation-color": "white",
        "--swiper-navigation-size": "40px",
        "--swiper-navigation-background": "black",
        "--swiper-pagination-color": "#A91E24",
        "--swiper-pagination-bullet-inactive-color": "#999999",
        "--swiper-pagination-bullet-active-color": "#A91E24",
        "--swiper-pagination-bullet-inactive-opacity": "1",
        "--swiper-pagination-bullet-size": "10px",
        "--swiper-pagination-bullet-horizontal-gap": "6px",
      }}
      modules={[Keyboard, Pagination, Navigation, EffectFlip, Autoplay]}
      spaceBetween={0}
      slidesPerView={1}
      onSwiper={(swiper) => console.log(swiper)}
      // navigation
      autoplay={{ delay: 5000 }}
      pagination={{ clickable: true }}
      effect="flip"
    >
      {hero.map(({ image }, index) => (
        <SwiperSlide key={index}>
          <div className=" relative h-heroHeight w-full">
            <img
              src={image}
              alt="hero"
              className="w-full h-full absolute  object-cover"
            />

            <div className="absolute w-full h-full">
              <div className="m-auto w-11/12 flex justify-center items-center h-full">
                <div className="relative">
                  <h1 className="font-PlayfairDisplay font-medium md:font-bold text-center text-3xl md:text-5xl lg:text-6xl text-white ">
                    Choose your own rules
                  </h1>
                  <p className="mt-5 md:mt-5 text-white font-medium text-center text-base md:text-3xl ">
                    {index === 0
                      ? "Buy, Sell, Preloved quality fashion"
                      : "With Thrifit, limits don't exist"}
                  </p>
                  <div className="mt-3 md:mt-8 flex justify-center">
                    <div
                      className={`w-full md:w-450 flex flex-col md:flex-row ${
                        user.data ? "justify-center" : "justify-between"
                      } items-center`}
                    >
                      {!user.data ? (
                        <div className="w-3/4 lg:w-full">
                          <Link to="/sign-up">
                            <Btn bg="bg-red-800" innerText="Get Started" />
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}

                      <div
                        className={`w-3/4 ${
                          user.data ? "md:w-fit" : "lg-w-full"
                        } ${user.data ? "m-auto" : ""}`}
                      >
                        <Link to="/communities">
                          <Btn bg="bg-black" innerText="Explore Communities" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Slider;
